export const ADD_TODO = 'ADD_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const MARK_TODO_AS_DONE = 'MARK_TODO_AS_DONE';
export const MARK_TODO_AS_ONGOING = 'MARK_TODO_AS_ONGOING';


